module.exports = __webpack_public_path__ + "img/ESDbackground-min.5ba4f08d.jpg";